import { RequestNewHealerDto } from './dto/request-new-healer-dto';
import { AxiosResponse } from 'axios';
import backendHttpClient, { administrationHttpClient } from '../../../http/axios/axios-http-client';

const ENDPOINT_CREATE_REQUEST = '/public/client/create/with-recommendation-request';
const ENDPOINT_FETCH_RECOMMENDATIONS = '/public/healers-recommendation/request';

export interface RequestNewHealerGateway {
  requestNewHealer(body: RequestNewHealerDto): Promise<CreateWithRecommendationResponse>;
}

export interface CreateWithRecommendationResponse {
  recommendationRequestId: string;
  clientId: string;
}

export interface RecommendationResponse {
  id: string;
  firstHealerId: string;
  firstHealerFullName: string;
  secondHealerId: string;
  secondHealerFullName: string;
  thirdHealerId: string;
  thirdHealerFullName: string;
  firstHealerPersonalizedMessage: string;
  secondHealerPersonalizedMessage: string;
  thirdHealerPersonalizedMessage: string;
  luminaraAuthor: string;
  createdDate: string;
  requestCompletitionTime: string;
  openedAt: string | null;
  bookHealerButtonClickedAt: string | null;
  administratorNotes: string | null;
}

export class RequestNewHealerGateway implements RequestNewHealerGateway {
  async requestNewHealer(body: RequestNewHealerDto): Promise<CreateWithRecommendationResponse> {
    const response: AxiosResponse<CreateWithRecommendationResponse> = await administrationHttpClient.request({
      url: ENDPOINT_CREATE_REQUEST,
      method: 'POST',
      data: body,
    });

    return response.data;
  }

  async fetchRecommendationByRequestId(recommendationRequestId: string): Promise<RecommendationResponse> {
    const response: AxiosResponse<RecommendationResponse> = await backendHttpClient.request({
      url: `${ENDPOINT_FETCH_RECOMMENDATIONS}/${recommendationRequestId}`,
    });

    return response.data;
  }
}
